const options = {
  nowrap: "nowrap",
  wrap: "wrap",
  wrapReverse: "wrap-reverse",
};

export default function getFlexWrap(wrap) {
  return options[wrap];
}
